import { Box, Typography } from '@mui/material';

export const EmptyFeed = () => (
  <Box className="flex flex-col items-center gap-5 mt-[92px]">
    <Typography variant="h1" className="text-gray-4 font-extrabold">
      Nothing to see here yet 👀
    </Typography>
    <Typography align="center" className="text-gray-4 md:w-[523px] sm:w-[90%]">
      {`Start a conversation with your subscribers by typing something in the box above. Don't know what to post? Check out suggestions `}
      <a
        href="https://playbookapp.io/handbook/community-tutorial-best-practices#how-community-works"
        target="_blank"
        rel="noreferrer"
      >
        here
      </a>
      .
    </Typography>
  </Box>
);
